import { withApiBase } from "./base";

export async function fetchSports(query = "") {
  const params = new URLSearchParams();
  if (query.trim()) params.set("q", query.trim());

  const url = withApiBase(`/sports${params.toString() ? `?${params}` : ""}`);
  const res = await fetch(url);
  if (!res.ok) throw new Error("Cannot load sports");
  return res.json();
}
